module.exports = __webpack_public_path__ + "assets/pdf-active.f092f07e.svg";